import { Box, Divider, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme, isactive }) => ({
  border: isactive ? "2px solid #126ABC" : theme.borders.highlighted,
  borderRadius: theme.borderRadius.radius.custom,
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.blackColor,
}));
export const StyledTypographyMember = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.micro.fontSize,
  color: theme.palette.custom.listGroupColor,
}));
export const StyledTypographyDay = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.mini.fontSize,
  color: theme.palette.custom.lockerValueColor,
}));
export const GroupDetailsContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px 16px",
  gap: "10px",
  flexWrap: "wrap",
}));
export const GroupOverviewBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
}));
export const StyledDivider = styled(Divider)(() => ({
  marginTop: "8px",
}));
